(() => {
  const build = (link) => {
    const context = document.getElementById('vertaro-sms-context');
    const picker = document.querySelector('variant-picker[data-template-product-match="true"]');
    const title = picker?.dataset.productTitle || context?.dataset.productTitle;
    const url = new URL(context?.dataset.pageUrl || window.location.href);
    url.search = '';
    url.hash = '';
    const options = new Map();
    if (title && picker) {
      picker.querySelectorAll('input[type="radio"]:checked, select option:checked').forEach(option => {
        if (option.dataset.optionName && option.value) options.set(option.dataset.optionName, option.value);
      });
      picker.querySelectorAll('[data-testid="variant-option-single"]').forEach(option => {
        const value = option.querySelector('[data-testid="variant-option-single-value"]')?.textContent.trim();
        const label = Array.from(option.childNodes).filter(node => node.nodeType === 3).map(node => node.textContent).join('').trim();
        if (label && value) options.set(label, value);
      });
      const section = picker.closest('.shopify-section');
      const variantId = section?.querySelector('product-form-component input[name="id"]')?.value;
      if (variantId && /^\d+$/.test(variantId)) url.searchParams.set('variant', variantId);
    }
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (link.getAttribute('href').startsWith('mailto:')) {
      const subject = title ? 'Question about ' + title + ' | VERTARO' : 'Website question | VERTARO';
      const lines = ['Hi VERTARO team,', title ? "I'm interested in " + title + " and would like some help." : "I'd like some help with this page.", ''];
      const sortedOptions = Array.from(options).sort(([a], [b]) => {
        const rank = name => /colou?r/i.test(name) ? 0 : /size/i.test(name) ? 1 : 2;
        return rank(a) - rank(b);
      });
      sortedOptions.forEach(([name, value]) => lines.push(name + ': ' + value));
      lines.push((title ? 'Product link: ' : 'Page link: ') + url.href, '', 'My question:');
      const body = encodeURIComponent(lines.join('\n'));
      link.href = 'mailto:support@wearvertaro.com?subject=' + encodeURIComponent(subject) + '&body=' + body;
    } else {
      const details = Array.from(options).sort(([a], [b]) => {
        const rank = name => /colou?r/i.test(name) ? 0 : /size/i.test(name) ? 1 : 2;
        return rank(a) - rank(b);
      }).map(([name, value]) => /colou?r/i.test(name) ? value : name.toLowerCase() + ' ' + value).join(', ');
      const intro = title ? 'Hi VERTARO, I have a question about ' + title + (details ? ' (' + details + ')' : '') + '.' : 'Hi VERTARO, I have a question about this page.';
      const body = encodeURIComponent([intro, url.href, 'My question:'].join('\n'));
      link.href = 'sms:+12136759719' + (ios ? '&' : '?') + 'body=' + body;
    }
  };
  const selector = 'a[href^="sms:+12136759719"], a[href^="mailto:support@wearvertaro.com"]';
  document.querySelectorAll(selector).forEach(build);
  document.addEventListener('click', event => {
    const link = event.target.closest(selector);
    if (link) build(link);
  }, true);
})();